import api from '.';
import { BusinessUnit } from '../pages/BusinessUnit/businessUnitSlice';

interface ReturnGetBusinessUnitsType {
  data: BusinessUnit[];
}

export async function getBusinessUnits(): Promise<ReturnGetBusinessUnitsType> {
  const { data } = await api.get(
    `${process.env.REACT_APP_PROJECT_REGISTER_URL}/business-units`
  );
  return data;
}

// New function for Plug and Play - use local API instead of Project Register
export async function getBusinessUnitsLocal(): Promise<ReturnGetBusinessUnitsType> {
  const { data } = await api.get('/business-units');
  return data;
}

export async function getBusinessUnit(id: number): Promise<BusinessUnit> {
  const { data } = await api.get(`/business-units/${id}`);
  return data;
}
